import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { AlertCircle } from 'lucide-react';

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <AlertCircle className="w-16 h-16 text-destructive mx-auto mb-4" />
        <h1 className="text-3xl font-bold mb-2">Acceso No Autorizado</h1>
        <p className="text-muted-foreground mb-6">
          No tienes permisos para acceder a esta página.
        </p>
        <Button onClick={() => navigate('/login')} data-testid="back-to-login-button">
          Volver al Inicio de Sesión
        </Button>
      </div>
    </div>
  );
}
